<template>
    <v-dialog
        v-model="reply.dialog"
        :max-width="options.width"
        persistent
        v-bind:style="{ zIndex: options.zIndex }"
        content-class="">
        <v-form ref="forms">
            <v-card class="dialog-card">
                <v-card-title class="title blue-title pa-3 pt-4 ml-2">
                    Reply
                    <div class="header-close" title="close" @click="reply.dialog=false"><v-icon>close</v-icon></div>
                </v-card-title>
                <v-card-text>   
                    <v-layout wrap px-2>
                        <v-flex xs12>
                            <div class="blue-title mb-3" v-for="(value,i) in reply.items" :key="i">
                                <p class="font-weight-bold mb-1">{{value.Item1==0?'Yourself':'Admin'}}</p>
                                <div class="format-text">{{value.Item2}}</div>
                                <span>{{formaterTimes(value.Item3)}}</span>
                            </div>
                        </v-flex>
                        <v-flex xs12 v-if="reply.status!==10 && reply.code!==20">
                            <v-flex xs12>
                                <v-subheader class="pa-0 form-title">Remark</v-subheader>
                            </v-flex>
                            <v-textarea 
                                    v-model.trim="remark" 
                                    single-line 
                                    outline 
                                    no-resize 
                                    :rules="[rules.required, rules.length]"
                                    rows="5" 
                                    counter="600"
                                    ></v-textarea>
                            </v-flex> 
                    </v-layout>
                    <v-layout row>
                        <v-flex xs12 class="text-xs-center mt-3">
                        <v-btn v-if="reply.status!==10 && reply.code!==20"
                                class="text-none red-button dialog-submit"
                                @click="submit"
                                :loading="submitting"
                                >Submit</v-btn>
                            <v-btn class="text-none cancel-button"
                                @click="reply.dialog=false"
                                >Cancel</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>

            </v-card>
        </v-form>
    </v-dialog>
</template>
<script>
import { replyAdd } from '@/api/feedBack.js'
import { formatDate } from '@/utils/date'
import {getFeedBackMsg} from '@/api/feedBack'
import store from '@/store'

export default {
    data:()=>({
        options:{
            width: 600,
            zIndex: 200
        },
        remark: '',
        rules: {
            length: v => v.length <= 600 || 'Max 600 characters',
            required: v => !!v || 'Required.'
        },
        submitting: false
    }),
    props: {
        reply: {
            dialog: false,
            id:0,
            status:'',
            items:[],
            code:0,
            msgStatus:Number
        }
    },
    mounted(){
    },
    methods:{
        submit(){
            if (!this.$refs.forms.validate()) {
                return
            }
            this.submitting = true;
            replyAdd(this.reply.id,this.remark).then(res=>{
                if(res.data.ErrorCode===0){
                    let type = res.data.Body.Item1?'success':'error';
                    this.$root.$alertTips(res.data.Body.Item2,type).then(()=>{
                        if(type=='success') this.reply.dialog=false;
                    })
                }
            }).finally(()=>{
                this.submitting = false;
            })
        },
        formaterTimes (e) { 
            return formatDate(e, 'MM-dd-yyyy hh:mm:ss')
        }
    },
    watch:{
        'reply.dialog': function (value, oldValue) {
            if (value !== oldValue) {
                this.$refs.forms.resetValidation()
                this.remark = ''
                if (this.reply.msgStatus==2) {
                    getFeedBackMsg().then(res=>{
                         store.dispatch('setFeedBackMsgDialog',res.data.Body)
                    })
                }
            }
        }
    }
}
</script>
<style scoped>
.format-text{
    width:552px;
    word-break: break-word;
}
</style>